import {
  privateRoutesEmployerAdditional,
  privateRoutes,
  privateRoutesProjectEditor,
  privateRoutesSupervisor,
  privateRoutesProjectManager,
  privateRoutesEmployer,
  privateRoutesModerator,
  privateRoutesSafetyEngineer,
  adminRoutes,
  privateRoutesContractor,
  privateRoutesFieldContractor,
} from "../router/index.js";

export const getRoute = (userRole) => {
  switch (userRole) {
    case "admin":
      return adminRoutes;
    case "supervisor":
      return privateRoutesSupervisor;
    case "project_manager":
      return privateRoutesProjectManager;
    case "employer":
      return privateRoutesEmployer;
    case "moderator":
      return privateRoutesModerator;
    case "contractor":
      return privateRoutesContractor;
    case "safety_engineer":
      return privateRoutesSafetyEngineer;
    case "project_editor":
      return privateRoutesProjectEditor;
    case "employer_additional":
      return privateRoutesEmployerAdditional;
    case "field_contractor":
      return privateRoutesFieldContractor;
    default:
      return privateRoutes;
  }
};
